import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { LabeledValue } from '../../../../../../controls/labeled-value';
import { FormDetails, getFormDetails } from '../../form-details-reducer';
import { connect } from 'react-redux';
import { State } from '../../../../../../redux/root-reducer';
import { OpenModal, openModalAction } from '../../../../../../form-modal/actions';
import { getClaim } from '../../../../../../claim';
import { ClaimType } from '../../../../../../claim/claim-types';
import { Nullable } from '../../../../../../shared-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}
interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const paymentDetailsView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
    openModal,
    disableEditButton,
    claimType,
}: Props) => {
    function toUpperCaseBankFirstLetterOnly(str: string) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    const paymentDetails = formDetails?.payment?.information || {};
    const paymentInfo = formDetails?.payment?.paymentInformation || {};

    return (
        <ExpansionPanel name="Payment details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <Grid container justify="space-between" className={classes.marginTop2}>
                    <Grid container item xs={12} alignItems="center">
                        <Typography className={classes.heading} variant="body1">
                            {isDisabilityOrRetrenchment() ? 'Payment Details' : 'Payee Details'}
                        </Typography>
                    </Grid>
                </Grid>
                <Paper className={classes.paper}>
                    {claimType !== ClaimType.Disability && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={3}>
                                <LabeledValue
                                    label="Payment must be made into the account of"
                                    value={paymentDetails.paymentBeneficiary}
                                />
                            </Grid>
                            {paymentDetails.bankName && (
                                <Grid item xs={12} md={6} lg={3}>
                                    <LabeledValue
                                        label="Bank Name"
                                        value={paymentDetails.bankName}
                                    />
                                </Grid>
                            )}
                            {paymentDetails.branchCode && (
                                <Grid item xs={12} md={6} lg={3}>
                                    <LabeledValue
                                        label="Branch Code"
                                        value={paymentDetails.branchCode}
                                    />
                                </Grid>
                            )}
                            {paymentDetails.accountNumber && (
                                <Grid item xs={12} md={6} lg={3}>
                                    <LabeledValue
                                        label="Account Number"
                                        value={paymentDetails.accountNumber}
                                    />
                                </Grid>
                            )}
                            {paymentDetails.accountType && (
                                <Grid item xs={12} md={6} lg={3}>
                                    <LabeledValue
                                        label="Account Type"
                                        value={paymentDetails.accountType}
                                    />
                                </Grid>
                            )}
                            {paymentDetails.branchName && (
                                <Grid item xs={12} md={6} lg={3}>
                                    <LabeledValue
                                        label="Branch Name"
                                        value={paymentDetails.branchName}
                                    />
                                </Grid>
                            )}
                            {paymentDetails.relationshipToAccountHolder && (
                                <Grid item xs={12} md={6} lg={3}>
                                    <LabeledValue
                                        label="Account holder relationship"
                                        value={paymentDetails.relationshipToAccountHolder}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    )}
                    {isDisabilityOrRetrenchment() && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={3}>
                                <LabeledValue
                                    label="Payment must be made into the account of"
                                    value={paymentInfo.paymentBeneficiary}
                                />
                            </Grid>
                            {paymentInfo.paymentBeneficiary !== 'Cessionary' && (
                                <>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Bank Name"
                                            value={toUpperCaseBankFirstLetterOnly(
                                                paymentInfo?.bankName || ''
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Account Number"
                                            value={paymentInfo.accountNumber}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Account Type"
                                            value={paymentInfo.accountType}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Account holder relationship"
                                            value={paymentInfo.accountHolderRelationship}
                                        />
                                    </Grid>
                                    {paymentInfo.doesAccountBelongToAnIndividualOrABusiness !==
                                        'Company' && (
                                        <Grid item xs={12} md={6} lg={3}>
                                            <LabeledValue
                                                label="Is Account Holder South African Resident?"
                                                value={
                                                    paymentInfo.isTheAccountHolderASouthAfricanResident
                                                }
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Branch Name"
                                            value={paymentInfo.branchName}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Branch Code"
                                            value={paymentInfo.branchCode}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <LabeledValue
                                            label="Does account belong to an individual or a business?"
                                            value={
                                                paymentInfo.doesAccountBelongToAnIndividualOrABusiness
                                            }
                                        />
                                    </Grid>

                                    {paymentInfo.doesAccountBelongToAnIndividualOrABusiness ===
                                        'Individual' && (
                                        <>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <LabeledValue
                                                    label="Full first names of account holder"
                                                    value={paymentInfo.fullFirstNameOfAccountHolder}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <LabeledValue
                                                    label="Surname"
                                                    value={paymentInfo.surname}
                                                />
                                            </Grid>

                                            {paymentInfo.isTheAccountHolderASouthAfricanResident ===
                                                'Yes' && (
                                                <Grid item xs={12} md={6} lg={3}>
                                                    <LabeledValue
                                                        label="ID Number"
                                                        value={paymentInfo.idNumber}
                                                    />
                                                </Grid>
                                            )}
                                            {paymentInfo.isTheAccountHolderASouthAfricanResident ===
                                                'No' && (
                                                <>
                                                    <Grid item xs={12} md={6} lg={3}>
                                                        <LabeledValue
                                                            label="Passport number"
                                                            value={paymentInfo.passportNumber}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6} lg={3}>
                                                        <LabeledValue
                                                            label="Country of residence"
                                                            value={paymentInfo.countryOfResidence}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                            {paymentInfo.paymentBeneficiary === 'Premium Payer' && (
                                                <Grid item xs={12} md={6} lg={3}>
                                                    <LabeledValue
                                                        label="Relationship to policyholder"
                                                        value={
                                                            paymentInfo.relationshipToPolicyHolder
                                                        }
                                                    />
                                                </Grid>
                                            )}
                                        </>
                                    )}
                                    {paymentInfo.doesAccountBelongToAnIndividualOrABusiness ===
                                        'Company' && (
                                        <>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <LabeledValue
                                                    label="Country of Company"
                                                    value={paymentInfo.countryOfcompany}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <LabeledValue
                                                    label="Company Name"
                                                    value={paymentInfo.companyName}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <LabeledValue
                                                    label="Company Registration Date"
                                                    value={
                                                        paymentInfo.companyRegistrationDate
                                                            ? new Date(
                                                                  paymentInfo.companyRegistrationDate
                                                              ).toLocaleDateString()
                                                            : ''
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <LabeledValue
                                                    label="Company Registration Number"
                                                    value={paymentInfo.companyRegistrationNumber}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </>
                            )}
                        </Grid>
                    )}
                </Paper>
            </React.Fragment>
        </ExpansionPanel>
    );

    function isDisabilityOrRetrenchment() {
        return claimType === ClaimType.Disability || claimType === ClaimType.Retrenchment;
    }
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
};

export const PaymentDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(paymentDetailsView));
